import React from 'react';
import classes from "./Layout.module.css";
import { useDispatch, useSelector } from 'react-redux';
import { setSidebar } from '../store/slices/sidebarSlice';
import { Button } from 'primereact/button';
import { setDrawer } from '../store/slices/drawerSlice';
import { FaRegUser, FaBan, FaRegSnowflake, FaRegRectangleList, FaArrowLeft, FaArrowRight, FaBarsStaggered } from "react-icons/fa6";
import Drawer from './Drawer';
import { useNavigate } from 'react-router-dom';
import { removeToken } from '../store/slices/tokenSlice';

const Layout = ({ children, active }) => {
    const { sidebar } = useSelector(state => state?.sidebarSlice);
    const { drawer } = useSelector(state => state?.drawerSlice);
    const { tokenData } = useSelector(state => state?.tokenSlice);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const toggleSidebar = () => {
        dispatch(setSidebar(!sidebar));
    }
    const toggleDrawer = () => {
        dispatch(setDrawer(!drawer));
    }

    const handleLogout = () => {
        dispatch(removeToken());
        navigate("/");
    }
    return (
        <>
            <main className={`${classes.main} ${!sidebar && classes.short}`}>
                <div className={`${classes.sidebar} ${!sidebar && classes.short}`}>

                    <div className={classes.sidebar_menu_icon} onClick={toggleSidebar} >
                        {sidebar ? <FaArrowLeft className={classes.menu_icon} /> : <FaArrowRight className={classes.menu_icon} />}
                    </div>

                    <div className={classes.sidebar_sub_container}>
                        <div className={`${classes.logo} ${!sidebar && classes.short}`}>
                            <img src='/assets/images/logo.png' alt='rainbow' className={classes.logo_image} />
                        </div>

                        <div className={classes.sidebar_items}>
                            {tokenData?.admin == 'rainboo' &&
                                <button className={`${classes.sidebar_item} ${active === 0 && classes.active}`}
                                    onClick={() => navigate("/home")}
                                >
                                    <FaRegRectangleList className={classes.sidebar_icon} />
                                    {sidebar ? <p className={classes.btn_text}>
                                        MIS
                                    </p> : null}

                                </button>
                            }
                            <button className={`${classes.sidebar_item} ${active === 1 && classes.active}`}
                                onClick={() => navigate("/user-logs")}

                            >
                                <FaRegUser className={classes.sidebar_icon} />
                                {sidebar ? <p className={classes.btn_text}>
                                    User Logs
                                </p> : null}

                            </button>
                            <button className={`${classes.sidebar_item} ${active === 2 && classes.active}`}
                                onClick={() => navigate("/user-blacklist")}

                            >
                                <FaBan className={classes.sidebar_icon} />
                                {sidebar ? <p className={classes.btn_text}>
                                    User Blacklist
                                </p> : null}

                            </button>
                            <button className={`${classes.sidebar_item} ${active === 3 && classes.active}`}
                                onClick={() => navigate("/leaderboard")}

                            >
                                <FaRegSnowflake className={classes.sidebar_icon} />
                                {sidebar ? <p className={classes.btn_text}>
                                    Leaderboard
                                </p> : null}

                            </button>

                            <button className={`${classes.sidebar_item} ${active === 4 && classes.active}`}
                                onClick={() => navigate("/unsubscription")}

                            >
                                <FaRegSnowflake className={classes.sidebar_icon} />
                                {sidebar ? <p className={classes.btn_text}>
                                    Unsubscription
                                </p> : null}

                            </button>
                        </div>
                    </div>
                </div>
                <div className={classes.container}>
                    <header className={classes.header}>
                        <button className={classes.menu_drawer_button} onClick={toggleDrawer}>
                            <FaBarsStaggered className={classes.menu_drawer} />
                        </button>
                        <p className={classes.header_title}>
                            QuizMaster Moov Niger
                        </p>
                        <Button label="Logout" severity="danger" onClick={handleLogout} />
                    </header>

                    <div className={classes.sub_container}>
                        {children}
                    </div>
                </div>
            </main>
            <Drawer active={active} />
        </>

    )
}

export default Layout